<template>
    <v-card class="flex-grow-1 d-flex flex-column" style="width: 100%; height: 100%;">
        <v-toolbar card color="primary subheading" dark height="64" class="flex-grow-0 d-flex" v-if="showNavigationAndFilters">
            <v-layout row align-start justify-right>
                <v-flex shrink align-self-center v-if="isTabletMode">
                    <v-toolbar-side-icon @click.native="toggleDisplayNav"></v-toolbar-side-icon>
                </v-flex>
                <v-flex grow align-self-center>
                    <span class="title">{{ title }}</span>
                </v-flex>

                <v-flex shrink>
                    <ForecastingOverviewWeather></ForecastingOverviewWeather>
                </v-flex>
            </v-layout>
        </v-toolbar>
        <v-container :class="`${isTabletMode ? `pa-0` : `pa-2`} flex-grow-1 d-flex flex-column`" fluid>
            <v-layout row align-start justify-center :class="`flex-grow-0 py-1`" v-if="showNavigationAndFilters">
                <v-flex>
                    <ForecastingOverviewFilters
                        :routePlantId="routePlantId"
                        :routeProductCategoryId="routeProductCategoryId"
                        :routeCropLocationId="routeCropLocationId"
                        :routeVarietyId="routeVarietyId"
                        @goToDetail="$emit('goToDetail', $event)"
                        >
                    </ForecastingOverviewFilters>
                </v-flex>
            </v-layout>
            <v-layout v-if="loading" row justify-center align-center class="flex-grow-1">
                <v-flex shrink>
                    <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
            </v-layout>
            <v-layout v-else row class="flex-grow-1 d-flex">
                <v-flex class="flex-grow-1 d-flex">
                    <ForecastingOverviewList v-if="isListMode"
                        @goToDetail="$emit('goToDetail', $event)">
                    </ForecastingOverviewList>
                    <ForecastingOverviewCalendar v-else-if="isCalendarMode"
                        @goToDetail="$emit('goToDetail', $event)">
                    </ForecastingOverviewCalendar>
                </v-flex>
            </v-layout>
            <v-layout class="flex-grow-0">
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
import ForecastingOverviewModes from '@/helpers/forecastingOverviewModes'
import ForecastingOverviewWeather from '@/components/forecasting/ForecastingOverviewWeather.vue'
import ForecastingOverviewFilters from '@/components/forecasting/ForecastingOverviewFilters.vue'
import ForecastingOverviewList from '@/components/forecasting/ForecastingOverviewList.vue'
import ForecastingOverviewCalendar from '@/components/forecasting/ForecastingOverviewCalendar.vue'
import { mapState } from 'vuex';

export default {
    components: {
        ForecastingOverviewWeather,
        ForecastingOverviewFilters,
        ForecastingOverviewList,
        ForecastingOverviewCalendar
    },
    props: {
        routePlantId: {
            type: Number,
            required: false
        },
        routeProductCategoryId: {
            type: Number,
            required: false
        },
        routeCropLocationId: {
            type: Number,
            required: false
        },
        routeVarietyId: {
            type: Number,
            required: false
        }
    },
    data(){
        return {
            mode: ForecastingOverviewModes.Calendar,
            forecastingSettingsDialog: false,
        }
    },
    computed: {
        ...mapState("ForecastingStore", [
            "loadingCropVarieties",
            "showNavigationAndFilters",
        ]),
        loading(){
            return this.loadingCropVarieties;
        },
        isListMode(){
            return this.mode === ForecastingOverviewModes.List
        },
        isCalendarMode(){
            return this.mode === ForecastingOverviewModes.Calendar
        },
        title(){
            if(this.isListMode){
                return "Costa HMS - Forecasting List View";
            }

            if(this.isCalendarMode){
                return "Costa HMS - Forecasting Calendar View";
            }

            return "";
        },
        isTabletMode(){
            return this.$vuetify.breakpoint.mdAndDown;
        }
    },
    methods: {
        toggleDisplayNav() {
            this.$store.commit("GeneralStore/toggleDisplayNavDrawer");
        },
    },
    created(){

    }
}
</script>

<style scoped>
.flex-column {
    flex-direction: column!important;
}

.flex-row {
    flex-direction: row!important;
}

.d-flex {
    display: flex!important;
}

.flex-grow-1 {
    flex-grow: 1!important;
}

.flex-grow-0 {
    flex-grow: 0!important;
}
</style>